import { Typography } from "@mui/material"

export default function CrewPlaceholder() {
    return (
        <div className="w-full p-2 bg-[#00263a] relative flex flex-row items-center">
            <Typography sx={{color: "#fff", pl: "1rem", position: 'sticky', left: '1rem'}}>No crews available</Typography>
        </div>
    )
}